import { CLEAR_ERROR, CLOSE_ERROR } from './types';
import type { Action } from '../../types';

export const closeError = (): Action => ({
  type: CLOSE_ERROR,
});

export const clearError = (): Action => ({
  type: CLEAR_ERROR,
});
